import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { HYDRATE } from 'next-redux-wrapper';

export const BASEQUERY_TYPES = {
  graphql: 'graphql',
  getEntries: 'getEntries',
};

async function baseQuery(args, _, {
  client,
  type = BASEQUERY_TYPES.getEntries,
} = {}) {
  try {
    let requestClient = client;

    if (!requestClient) {
      const { contentfulClient } = await import('utils/contentful/client');
      requestClient = contentfulClient;
    }

    const result = await requestClient[type](args);

    return { data: result };
  } catch (e) {
    if (type === BASEQUERY_TYPES.getEntries && e.message === '404') {
      try {
        const { fallbackClient } = await import('utils/contentful/client');
        const result = await fallbackClient[type](args);

        return { data: result };
      } catch (err) {
        return { error: err.message };
      }
    }

    return { error: e.message };
  }
}

const baseApi = createApi({
  reducerPath: 'api',
  baseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath];
    }
  },
  endpoints: () => ({}),
});

export default baseApi;
